import React from 'react';
import { useNavigate } from 'react-router-dom';

const TermsPage = () => {
  const navigate = useNavigate();

  return (
    <div data-testid="terms-page" style={{ minHeight: '100vh', backgroundColor: '#000', color: '#FAF3E0', fontFamily: "'Georgia', serif" }}>
      <div style={{ borderBottom: '1px solid rgba(212,175,55,0.15)', padding: '16px 32px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <span onClick={() => navigate('/')} style={{ cursor: 'pointer', fontFamily: "'Georgia', serif", fontSize: 20, color: '#D4AF37', letterSpacing: 4, fontWeight: 600 }}>
          BOBINE
        </span>
        <button onClick={() => navigate(-1)} style={{ fontFamily: "'Georgia', serif", fontSize: 13, color: '#D4AF37', background: 'none', border: '1px solid rgba(212,175,55,0.3)', borderRadius: 8, padding: '8px 20px', cursor: 'pointer' }}>
          Retour
        </button>
      </div>

      <div style={{ maxWidth: 720, margin: '0 auto', padding: '48px 24px 80px' }}>
        <div style={{ textAlign: 'center', marginBottom: 48 }}>
          <h1 data-testid="terms-title" style={{ fontSize: 28, color: '#D4AF37', fontWeight: 600, letterSpacing: 1.5, marginBottom: 8 }}>
            {"Conditions G\u00e9n\u00e9rales d\u2019Utilisation"}
          </h1>
          <div style={{ width: 60, height: 1, background: 'linear-gradient(145deg, #D4AF37, #B8860B)', margin: '16px auto', opacity: 0.4 }} />
          <p style={{ fontSize: 13, color: '#D4AF37', fontStyle: 'italic' }}>
            {"Derni\u00e8re mise \u00e0 jour\u00a0: mars 2026"}
          </p>
        </div>

        <section data-testid="terms-preambule" style={{ marginBottom: 36 }}>
          <h2 style={{ fontSize: 18, color: '#D4AF37', marginBottom: 12, fontWeight: 500 }}>{"Pr\u00e9ambule"}</h2>
          <p style={{ fontSize: 15, lineHeight: 1.8, color: '#FAF3E0' }}>
            {"Bienvenue sur Bobine. Notre mission est de vous aider \u00e0 pr\u00e9server et transmettre l\u2019h\u00e9ritage de votre famille en toute s\u00e9r\u00e9nit\u00e9."}
          </p>
        </section>

        <section data-testid="terms-service" style={{ marginBottom: 36 }}>
          <h2 style={{ fontSize: 18, color: '#D4AF37', marginBottom: 12, fontWeight: 500 }}>Le Service</h2>
          <p style={{ fontSize: 15, lineHeight: 1.8, color: '#FAF3E0' }}>
            {"Bobine est un coffre-fort num\u00e9rique permettant le stockage et la consultation de souvenirs (vid\u00e9os, photos, r\u00e9cits)."}
          </p>
        </section>

        <section data-testid="terms-tarification" style={{ marginBottom: 36 }}>
          <h2 style={{ fontSize: 18, color: '#D4AF37', marginBottom: 12, fontWeight: 500 }}>Tarification</h2>
          <p style={{ fontSize: 15, lineHeight: 1.8, color: '#FAF3E0' }}>
            {"L\u2019acc\u00e8s au service est propos\u00e9 via un abonnement de "}
            <strong style={{ color: '#D4AF37' }}>{"4,99\u00a0\u20ac / mois"}</strong>
            {". Ce tarif est fixe et sans engagement."}
          </p>
        </section>

        <section data-testid="terms-propriete" style={{ marginBottom: 36 }}>
          <h2 style={{ fontSize: 18, color: '#D4AF37', marginBottom: 12, fontWeight: 500 }}>{"Propri\u00e9t\u00e9"}</h2>
          <p style={{ fontSize: 15, lineHeight: 1.8, color: '#FAF3E0' }}>
            {"Vous restez l\u2019unique propri\u00e9taire de tout le contenu que vous t\u00e9l\u00e9chargez sur Bobine. Nous n\u2019avons aucun droit de propri\u00e9t\u00e9 sur vos souvenirs familiaux."}
          </p>
        </section>

        <section data-testid="terms-resiliation" style={{ marginBottom: 36 }}>
          <h2 style={{ fontSize: 18, color: '#D4AF37', marginBottom: 12, fontWeight: 500 }}>{"R\u00e9siliation"}</h2>
          <p style={{ fontSize: 15, lineHeight: 1.8, color: '#FAF3E0' }}>
            {"Vous pouvez interrompre votre abonnement \u00e0 tout moment d\u2019un simple clic via votre espace client (Portail Stripe)."}
          </p>
        </section>

        <section data-testid="terms-responsabilite" style={{ marginBottom: 36 }}>
          <h2 style={{ fontSize: 18, color: '#D4AF37', marginBottom: 12, fontWeight: 500 }}>{"Responsabilit\u00e9"}</h2>
          <p style={{ fontSize: 15, lineHeight: 1.8, color: '#FAF3E0' }}>
            {"L\u2019utilisateur est responsable de la conservation de ses acc\u00e8s et de la l\u00e9galit\u00e9 des contenus partag\u00e9s au sein de son cercle familial."}
          </p>
        </section>

        <div style={{ borderTop: '1px solid rgba(212,175,55,0.1)', paddingTop: 32, marginTop: 48, textAlign: 'center' }}>
          <p style={{ fontSize: 12, color: '#D4AF37' }}>
            {"Bobine \u2014 Le fil de la m\u00e9moire \u2022 "}
            <a href="mailto:bonjour@bobine.live" style={{ color: '#D4AF37', textDecoration: 'none' }}>bonjour@bobine.live</a>
          </p>
          <p style={{ fontSize: 11, color: '#D4AF37', marginTop: 8 }}>
            <a href="/privacy" style={{ color: '#D4AF37', textDecoration: 'none' }}>{"Politique de Confidentialit\u00e9"}</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;
